import React from 'react'

import { COACHING_INBOX } from '@/reducers/tasks/tasks.constants'
import { InboxRedirect } from '@/components/inbox/InboxRedirect'

export const CoachingInbox = () => {
  return <InboxRedirect inboxType={COACHING_INBOX} title="Balto Coaching" />
}
